import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import axios from 'axios'; // using axios because 'fetch' does not supports upload progress :-(

import { commands } from "./commands";
import { getCookie } from "./cookiesWrapper";
import { serialize } from "./serialize";
import Router from '@/router';
import { deepClone } from '@/modules/mm-utils';
var urlFirstPart = 'https://testmm.mindandmachine.ru';
var apiPrefix = '/rest_api/';
var isCordovaApp = !!window.cordova;
var csrfToken = '';
export var API_REQUEST = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cmd, inParams, cancelErrorEmit) {
    var command, params, serialized, url, options, urlParts, newUrlParts;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            command = commands[cmd];

            if (!command) {
              _context2.next = 20;
              break;
            }

            if (!inParams) inParams = {};
            params = deepClone(inParams); // CLONING because we'll delete temp '_' keys

            Object.keys(params).map(function (paramKey) {
              if (paramKey[0] === '_') delete params[paramKey];
            });

            if (command.defaultParams) {
              params = Object.assign({}, command.defaultParams, params);
            }

            serialized = serialize({
              params: params,
              method: command.method,
              serializer: command.serializer
            });
            url = apiPrefix;
            url += command.method === 'GET' ? command.url + serialized : command.url;

            if (isCordovaApp) {
              url = urlFirstPart + url;
            }

            options = {};
            options.method = command.method;
            options.body = serialized;
            urlParts = url.split('/');
            newUrlParts = urlParts.map(function (part) {
              var colonPos = part.indexOf(':');

              if (colonPos > -1) {
                var paramToInject = part.substr(colonPos + 1);
                return params[paramToInject] ? params[paramToInject] : part;
              } else {
                return part;
              }
            });
            url = newUrlParts.join('/');

            if (cmd === 'logIn') {// await purgeCookie({
              //   url: urlFirstPart,
              //   name: 'sessionid'
              // })
            }

            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              axios({
                url: url,
                method: command.method,
                data: options.body,
                headers: {
                  'X-CSRFToken': csrfToken,
                  'Content-Type': command.serializer === 'JSON' ? 'application/json' : 'multipart/form-data'
                }
              }).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          resolve([false, response.data]);
                          _context.next = 3;
                          return getCookie({
                            url: urlFirstPart,
                            name: 'csrftoken'
                          });

                        case 3:
                          csrfToken = _context.sent;

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }()).catch(function (e) {
                var _e$response, _e$response2;

                if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
                  // unauthorized
                  resolve([e, false]);

                  if (Router.currentRoute.path !== '/login') {
                    Router.push('/login').catch(function () {});
                    console.log('[API_REQUEST] Redirected to "Login". Reason "Unauthorized"');
                  }
                } else if (((_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status) === 400 && cmd === 'addUser') {
                  resolve([e, false]);
                } else {
                  resolve([e, false]);

                  if (!cancelErrorEmit) {
                    document.dispatchEvent(new CustomEvent('apiRequestError', {
                      detail: {
                        error: e
                      }
                    }));
                  }
                }
              });
            }));

          case 20:
            throw new Error("".concat(cmd, ": wrong command"));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function API_REQUEST(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();